<template>
  <v-tooltip top color="transparent" max-width="320">
    <template v-slot:activator="{ on, attrs }">
      <span class="info-ico" v-bind="attrs" v-on="on"></span>
    </template>
    <div class="white-bg-tooltip small-tooltip">
      <b>{{ capitalizedTerm }}:</b> {{ definition }}
    </div>
  </v-tooltip>
</template>

<script>
/**
 * Plain-English glossary tooltip - the AI Writer v2 info-tooltip pattern
 * (gray info-circle activator, white hover card).
 */
const GLOSSARY = {
  impressions: "The number of times your page appeared in Google's results, whether or not anyone clicked.",
  clicks: 'The number of times someone actually clicked through to your site from Google.',
  'ranking keywords': 'The different searches your pages appear for in Google.',
  'page 1': "How many different searches show your pages in Google's top 10 results, the first page most people ever see.",
  'best position': "Your highest spot in Google's results. Position 1 is the very top of the first page.",
  'top page': 'The single article that gained the most visibility this period.',
  'content plan': 'A group of related articles planned and written together to win one topic.',
  'new pages': 'Pages Google listed for the first time this period. New pages usually take 8-12 weeks to settle.',
}

export default {
  name: 'WinsGlossaryTerm',
  props: {
    term: {
      type: String,
      required: true,
    },
  },
  computed: {
    capitalizedTerm () {
      return this.term.charAt(0).toUpperCase() + this.term.slice(1)
    },
    definition () {
      return GLOSSARY[this.term] || this.term
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../Settings/wg-tokens.scss';

/* AI Writer v2 .info-ico (Hero.vue / TitleStep.vue), gray fill */
.info-ico {
  width: 16px;
  height: 16px;
  display: inline-block;
  flex-shrink: 0;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: $pop-ink-muted;
  -webkit-mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>') center / contain no-repeat;
  mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>') center / contain no-repeat;
}
</style>
